



































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
	ConsentConditionType,
	ConsentWithId,
	WaterMeter,
	ConsentConditionWithId,
	WaterExport,
} from '@/api';
import WaterConsentProfileEdit from '@/components/display/water-consent-profile-edit.vue';
import WaterConsentConditionEdit from '@/components/display/water-consent-condition-edit.vue';
import WaterExportEdit from '@/components/display/water-export-edit.vue';
import {
	ConsentConditionModule,
	ConsentConditionTypeModule,
	ConsentCouncil,
	ConsentModule,
	WaterExportModule,
	WaterExportWithTargetOrg,
} from '@/modules';

@Component({
	components: {
		WaterConsentProfileEdit,
		WaterConsentConditionEdit,
		WaterExportEdit,
	},
})
export default class WaterConsents extends Vue {
	private readonly rid = Math.random();

	loaded: boolean = false;
	consentModule: ConsentModule;
	consentConditionTypeModule: ConsentConditionTypeModule;
	waterExportModule: WaterExportModule;
	editConditionId: number | null = null;
	editWaterExportId: number | null = null;

	startDate: Date | null = null;
	endDate: Date | null = null;
	selectedConsentConditionType: number | null = null;
	consentConditionTypes: ConsentConditionType[] = [];
	waterExports: WaterExportWithTargetOrg[] = [];
	consent: (ConsentWithId & ConsentCouncil) | undefined = {
		consentConditions: [],
		consentIdentifier: undefined,
		endDate: undefined,
		startDate: undefined,
		councilId: undefined,
		productId: undefined,
		council: undefined,
	};

	@Prop() readonly productId!: number;
	@Prop() readonly waterMeters!: WaterMeter[];

	constructor() {
		super();

		this.consentModule = new ConsentModule();
		this.consentConditionTypeModule = new ConsentConditionTypeModule();
		this.waterExportModule = new WaterExportModule();
		this.selectedConsentConditionType = null;
	}

	public mounted() {
		this.loadConsent();
	}

	public async loadConsent() {
		this.consentConditionTypes = await this.consentConditionTypeModule.getConsentConditionTypes();
		this.waterExports = await this.waterExportModule.getWaterExportsForProduct(this.productId);
		const consents = await this.consentModule.getConsentsForProduct(this.productId);
		//products should only have one consent

		if (consents.length === 1) {
			this.consent = <ConsentWithId & ConsentCouncil>(<any>consents[0]);
			//sort by id so consistent order

			if (this.consent.consentconditions !== undefined && this.consent.consentconditions.length) {
				this.consent.consentconditions.sort((a, b) => (a.id > b.id ? 1 : -1));
			}
		}

		this.loaded = true;
	}

	public showUpdateConditionModal(
		isNew: boolean,
		conditionTypeId: number | undefined,
		conditionId: number | undefined,
	) {
		if (!isNew && conditionId !== undefined) {
			this.editConditionId = conditionId;
		} else if (isNew && conditionTypeId) {
			this.editConditionId = null;
		}
		this.$bvModal.show('water-consent-condition-edit-modal');
	}

	public showUpdateWaterExportModal(isNew: boolean, waterExportId: number) {
		if (waterExportId !== null) {
			this.editWaterExportId = waterExportId;
		} else {
			this.editWaterExportId = null;
		}
		this.$bvModal.show('water-export-edit-modal');
	}

	public async handleDeleteConditionClick(consentCondition: ConsentConditionWithId) {
		const consentConditionModule = new ConsentConditionModule();

		if (
			confirm(
				`Are you really really sure you want to delete the consent condition\n\n${consentCondition.displayText}`,
			)
		) {
			await consentConditionModule.delete(consentCondition.id);
			this.loadConsent();
		}
	}

	public async handleDeleteWaterExportButtonClick(waterExport: WaterExport) {
		if (confirm(`Are you really really sure you want to delete the water export`)) {
			await this.waterExportModule.delete(waterExport.id);
			this.loadConsent();
		}
	}
}
